import { render, staticRenderFns } from "./UserInputForm.vue?vue&type=template&id=09d81638&scoped=true&"
import script from "./UserInputForm.vue?vue&type=script&lang=ts&"
export * from "./UserInputForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserInputForm.vue?vue&type=style&index=0&id=09d81638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d81638",
  null
  
)

export default component.exports